export const authTranslations = {
  en: {
    continueWithout2FA: 'Continue without activating',
  },
  it: {
    continueWithout2FA: 'Continua senza attivare',
  }
};
